export default "__VITE_ASSET__DoRahdH4__"